import React, { useState } from "react";
import Days from "./Days";

const DoctorCard = ({img,name,days}) => {
	const [open,setOpen] = useState(false);

  return (
    <div className="collapsibleList">
      <div className="common">
        <div className="upper_card">
          <div className="row doctorDetail ">
            <div className="col-lg-2 col-5">
              <img src={img} alt="profile" className="doctorDetailImg w-100" />
            </div>
            <div className="col-lg-7 pl-lg-4 px-0 col-7">
              <h4 className="h3heading">{name}</h4>
              <h4 className="h3desc">Primary Care Doctor</h4>
              <div className="container-fluid">
              <div className="row">
                <div className="px=lg-3 px-md-2 px-1">
                  <span className="h4desc">
                    <svg
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.41333 6.14371C3.37333 8.03038 4.92 9.57038 6.80667 10.537L8.27333 9.07038C8.45333 8.89038 8.72 8.83038 8.95333 8.91038C9.7 9.15705 10.5067 9.29038 11.3333 9.29038C11.7 9.29038 12 9.59038 12 9.95705V12.2837C12 12.6504 11.7 12.9504 11.3333 12.9504C5.07333 12.9504 0 7.87705 0 1.61705C0 1.25038 0.3 0.950378 0.666667 0.950378H3C3.36667 0.950378 3.66667 1.25038 3.66667 1.61705C3.66667 2.45038 3.8 3.25038 4.04667 3.99705C4.12 4.23038 4.06667 4.49038 3.88 4.67705L2.41333 6.14371Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>{" "}
                    New York{" "}
                  </span>
                </div>
                <div className="px=lg-3 px-md-2 px-1">
                  <span className="h4desc">
                    <svg
                      width="10"
                      height="0.94rem"
                      viewBox="0 0 10 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.00065 0.380615C2.42065 0.380615 0.333984 2.54128 0.333984 5.21277C0.333984 8.83688 5.00065 14.1868 5.00065 14.1868C5.00065 14.1868 9.66732 8.83688 9.66732 5.21277C9.66732 2.54128 7.58065 0.380615 5.00065 0.380615ZM5.00065 6.93854C4.08065 6.93854 3.33398 6.16539 3.33398 5.21277C3.33398 4.26014 4.08065 3.487 5.00065 3.487C5.92065 3.487 6.66732 4.26014 6.66732 5.21277C6.66732 6.16539 5.92065 6.93854 5.00065 6.93854Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </svg>{" "}
                    +880 123 4567
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="px=lg-3 px-md-2 px-1">
                  <span className="h4desc">100 Reviews</span>
                </div>
                <div className="px=lg-3 px-md-2 px-1">
                  <svg
                    width="0.94rem"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.38004 12.8997L6.36743 12.0404C2.77089 9 0.396484 6.99479 0.396484 4.53385C0.396484 2.52865 2.08651 0.953125 4.23744 0.953125C5.45258 0.953125 6.61883 1.48047 7.38004 2.3138C8.14125 1.48047 9.3075 0.953125 10.5226 0.953125C12.6736 0.953125 14.3636 2.52865 14.3636 4.53385C14.3636 6.99479 11.9892 9 8.39266 12.0469L7.38004 12.8997Z"
                      fill="#25BCA7"
                    />
                  </svg>
                  <svg
                    width="0.94rem"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.38004 12.8997L6.36743 12.0404C2.77089 9 0.396484 6.99479 0.396484 4.53385C0.396484 2.52865 2.08651 0.953125 4.23744 0.953125C5.45258 0.953125 6.61883 1.48047 7.38004 2.3138C8.14125 1.48047 9.3075 0.953125 10.5226 0.953125C12.6736 0.953125 14.3636 2.52865 14.3636 4.53385C14.3636 6.99479 11.9892 9 8.39266 12.0469L7.38004 12.8997Z"
                      fill="#25BCA7"
                    />
                  </svg>
                  <svg
                    width="0.94rem"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.38004 12.8997L6.36743 12.0404C2.77089 9 0.396484 6.99479 0.396484 4.53385C0.396484 2.52865 2.08651 0.953125 4.23744 0.953125C5.45258 0.953125 6.61883 1.48047 7.38004 2.3138C8.14125 1.48047 9.3075 0.953125 10.5226 0.953125C12.6736 0.953125 14.3636 2.52865 14.3636 4.53385C14.3636 6.99479 11.9892 9 8.39266 12.0469L7.38004 12.8997Z"
                      fill="#25BCA7"
                    />
                  </svg>
                  <svg
                    width="0.94rem"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.83121 12.8997L6.8186 12.0404C3.22207 9 0.847656 6.99479 0.847656 4.53385C0.847656 2.52865 2.53768 0.953125 4.68861 0.953125C5.90375 0.953125 7.07001 1.48047 7.83121 2.3138C8.59242 1.48047 9.75868 0.953125 10.9738 0.953125C13.1248 0.953125 14.8148 2.52865 14.8148 4.53385C14.8148 6.99479 12.4404 9 8.84383 12.0469L7.83121 12.8997Z"
                      fill="#25BCA7"
                    />
                  </svg>
                  <svg
                    width="0.94rem"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.83121 12.8997L6.8186 12.0404C3.22207 9 0.847656 6.99479 0.847656 4.53385C0.847656 2.52865 2.53768 0.953125 4.68861 0.953125C5.90375 0.953125 7.07001 1.48047 7.83121 2.3138C8.59242 1.48047 9.75868 0.953125 10.9738 0.953125C13.1248 0.953125 14.8148 2.52865 14.8148 4.53385C14.8148 6.99479 12.4404 9 8.84383 12.0469L7.83121 12.8997Z"
                      fill="#25BCA7"
                    />
                  </svg>
                </div>
              </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="row">
								<div className="col-lg-12 col-6 px-2">
									<button onClick={()=> setOpen(o=>!o)} className="w-100 px-1 h4desc w-md-50 mt-lg-4 mt-3 active tableButton">
										BOOK AN APPOINTMENT
              		</button>
								</div>
								<div className="col-lg-12 col-6 px-2">
									<button className="w-100 h4desc w-md-50 mt-3 px-1 border tableButton">
										VIDEO CONSULTATION
									</button>
								</div>
							</div>
            </div>
          </div>
        </div>
      </div>
        {
					open ? <div className="control-me text-center bg-light pb-2 pt-4">
          {<Days open={open} days={days}/>}
        </div> : ""
				}
    </div>
  );
};

export default DoctorCard;
